import { __ } from "@wordpress/i18n";
import type { Intent, Stage } from "./auth-state-machine";

export type DefaultCopy = {
	modalTitle: string;
	accountCreationNote: string;
	successTitle: string;
	successMessage: string;
};

export function defaultCopyForIntent(intent: Intent): DefaultCopy {
	switch (intent) {
		case "signin":
			return {
				modalTitle: __("Sign in", "leat-crm"),
				accountCreationNote: "",
				successTitle: __("Welcome back", "leat-crm"),
				successMessage: __("You're signed in.", "leat-crm"),
			};
		case "signup":
			return {
				modalTitle: __("Create your account", "leat-crm"),
				accountCreationNote: __(
					"We'll create your account so you can start earning rewards.",
					"leat-crm",
				),
				successTitle: __("You're in!", "leat-crm"),
				successMessage: __(
					"Your loyalty account is ready. Welcome aboard.",
					"leat-crm",
				),
			};
		case "join":
			return {
				modalTitle: __("Join our loyalty program", "leat-crm"),
				accountCreationNote: "",
				successTitle: __("You've joined!", "leat-crm"),
				successMessage: __(
					"Welcome to the program. Your rewards are unlocked.",
					"leat-crm",
				),
			};
		case "auto":
		default:
			return {
				modalTitle: __("Sign in or join", "leat-crm"),
				accountCreationNote: __(
					"We'll create your account so you can start earning rewards.",
					"leat-crm",
				),
				successTitle: __("You're in!", "leat-crm"),
				successMessage: __(
					"Your loyalty account is ready. Welcome aboard.",
					"leat-crm",
				),
			};
	}
}

export function defaultSubmitTextForStage(stage: Stage): string {
	switch (stage) {
		case "emailEntry":
			return __("Continue", "leat-crm");
		case "password":
			return __("Sign in", "leat-crm");
		case "createAccount":
			return __("Create account & join", "leat-crm");
		case "joinExisting":
			return __("Join", "leat-crm");
		case "success":
			return __("Close", "leat-crm");
		default: {
			const _exhaustive: never = stage;
			throw new Error(`Unknown stage: ${_exhaustive}`);
		}
	}
}
